var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarStoreSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.86 -407.03)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M39.67,413.66v7.33c0,.24-.19.43-.43.43h-8.13c-.22,0-.41-.19-.41-.43v-5.69h-2.74v5.69c0,.24-.19.43-.41.43h-1.17c-.22,0-.41-.19-.41-.43v-7.26l.24.15c.13.09.31.11.46,0l1.35-.93,1.33.93c.15.09.33.11.48,0l1.35-.93,1.33.93c.13.09.33.11.46,0l1.35-.93,1.35.93c.13.09.31.11.46,0l1.35-.93,1.33.93c.15.09.33.11.48,0l.33-.22ZM29.25,407.03l-.76,3.96v1.28l1.13.78,1.2-.83v-1.28l.24-3.91h-1.81ZM27.67,412.21l-.02-1.22s0-.07.02-.11l.74-3.85h-1.81l-1.31,3.91v1.31l1.17.8,1.22-.83ZM31.9,407.03l-.26,3.94v1.3l1.15.78,1.2-.83v-1.24l-.22-3.94h-1.87ZM34.58,407.03l.22,3.91v1.33l1.15.78,1.2-.83v-1.22l-.78-3.96h-1.8ZM37.21,407.03l.76,3.85v1.39l1.13.78,1.19-.8v-1.3l-1.61-3.93h-1.46ZM37.4,415.49h-3.85v2.28h3.85v-2.28Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarStoreSettings);
export default __webpack_public_path__ + "static/media/sidebar_store_settings.eadd13ade14c63e1f972aeeae9008a79.svg";
export { ForwardRef as ReactComponent };